import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Readme.css';

const Readme = () => {
  const navigate = useNavigate();

  return (
    <div className="readme">
      <div className="readme-header">
        <h2>注意(最初にお読み下さい)</h2>
        <button
          className="back-button"
          onClick={() => navigate('/')}
        >
          ← 戻る
        </button>
      </div>
      <div className="readme-content">
        { "浦賀水道航路の入航予定を取得し、整理するサイトです。" }
        <br />
        { "入航予定は海上保安庁・東京湾海上交通センターが公開する航行情報を取得し、作成しています。" }
        <br />
        { "入航予定は海上保安庁のサイトに負荷をかけないよう、時間をおいて取得しています。" }
        <br />
        { "取得元で削除された入航予定についても一定時間内は表示しています。" }
        <br />
        { "表示される入航予定が実際の船舶の航行と一致するとは限りません。" }
        <br />
        { "本サイトの情報を実際の船舶の航行に利用しないで下さい。" }
        <br />
        { "本サイトは非公式であり、海上保安庁など関係各機関とは一切関係がありません。" }
        <br />
        { "本サイトの内容について海上保安庁など関係各機関に問い合わせることはおやめください。" }
        <br />
        当サイトの情報は<a href="https://x.com/nysalor" target="_blank" rel="noopener noreferrer">X(Twitter)</a>及び<a href="https://bsky.app/profile/nysalor.bsky.social" target="_blank" rel="noopener noreferrer">Bluesky</a>で発信しています。
        <br />
        { "created by @nysalor" }
        <br />
      </div>
    </div>
  );
};

export default Readme;

